import session from '@/shared/session'

// initial state
const state = {
	isComponentVisible: true,
}

// getters
const getters = {
    isComponentVisible: (state) => state.isComponentVisible,
}

// actions
const actions = {
	toggleComponentVisibility({ commit }) {
        commit('toggleComponentVisibility');
    },
}

// mutations
const mutations = {}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
